/* eslint-disable no-unused-vars */
import apiService from '@/utils/api-client'
import config from '@/utils/appConfig'
import store from '@/store'

export default {
  getDefiList: async function (
    { commit },
    {
      title = undefined,
      from = undefined,
      to = undefined,
      coin = undefined,
      $skip = undefined,
      $limit = undefined,
      archived = undefined,
      configParams = {},
    },
  ) {
    try {
      return apiService.get('report/defi', {
        params: { from, to, $skip, $limit, title, archived },
        cancelToken: configParams.cancelToken,
      })
    } catch (error) {
      console.error(error)
    }
  },
  getDefiReportById: async function ({ commit }, { enqId, searchingParams }) {
    try {
      return apiService.get(`report/defi/${enqId}`)
    } catch (error) {
      console.error(error)
    }
  },
  async createDefiReport(
    { commit },
    {
      title,
      directions,
      direction,
      address,
      tx_hash,
      token = undefined,
      maxDepth = undefined,
      thresholdAmount = undefined,
      ...extraParams
    },
  ) {
    try {
      return apiService.post('report/defi', {
        ...extraParams,
        title,
        directions,
        direction,
        address,
        tx_hash,
        token,
        maxDepth,
        thresholdAmount,
      })
    } catch (error) {
      console.error(error)
    } finally {
      await store.dispatch('user/getMe')
    }
  },
  async editDefiReport(
    { commit },
    {
      enqId,
      title = undefined,
      archived = undefined,
      kind = undefined,
      org_shared,
    },
  ) {
    try {
      return apiService.patch(`report/defi/${enqId}`, {
        title,
        archived,
        kind,
        org_shared,
      })
    } catch (error) {
      console.error(error)
    } finally {
      await store.dispatch('user/getMe')
    }
  },
  async deleteDefiReport({ commit }, { id }) {
    try {
      return apiService.delete(`report/defi/${id}`)
    } catch (error) {
      console.error(error)
    }
  },
  async getDefiSources(
    { commit },
    {
      enqId,
      directionUp,
      token = '',
      owner = undefined,
      fundsName = undefined,
      fundsRating = undefined,
      $skip = 0,
      $limit = 10,
      $sort = undefined,
    },
  ) {
    try {
      const data = apiService.get(`report/defi/${enqId}/sources`, {
        params: {
          enqId,
          directionUp,
          token,
          $skip,
          $limit,
          owner,
          funds: {
            name: fundsName,
            rating: fundsRating,
          },
          $sort,
        },
      })
      return data
    } catch (error) {
      console.error(error)
    }
  },
}
